import { css, styled } from 'styled-components';

import Link from 'components/Link';

const MegaMenuItemLink = styled(Link)(
  ({ theme }) => css`
    color: ${theme.colors.primaryBlack2};
    text-decoration: none;
    font-size: 0.875rem;
    font-weight: 600;
    height: 3.8125rem;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 0.1875rem solid transparent;

    &:hover {
      border-bottom: 0.1875rem solid ${theme.colors.primaryRed};
    }
  `
);

export default MegaMenuItemLink;
